<template>
  <nav
    id="navbar"
    class="relative z-[2] flex bg-white container-padding py-2"
  >
    <div class="flex items-center justify-between w-full rel">
      <!-- Left aligned items -->
      <div class="flex items-center">
        <!-- Brand image and link -->
        <div>
          <RouterLink
            class="py-0 flex items-center no-underline"
            :to="{ name: 'app_plan_list', params: { district: currentDistrict.id } }"
          >
            <div class="flex items-center">
              <img
                :src="Logo"
                alt="COGTA LivingPlans Logo"
                class="w-24 lg:w-32"
              >
            </div>
          </RouterLink>
        </div>

        <!-- Select district -->
        <RouterLink
          v-if="authStore.user.districts.length > 1"
          :to="{ name: 'app_district_select' }"
          class="hidden lg:block ml-3 py-1.5 px-3 !bg-secondary-light/20 !text-secondary border !border-secondary-light/40 !mb-0 hover:cursor-pointer rounded-lg font-semibold text-sm no-underline"
        >
          <span>{{ currentDistrict.name }}</span>
        </RouterLink>
      </div>

      <!-- Right aligned items -->
      <div class="flex items-center">
        <div class="flex justify-end items-center gap-4 mr-2">
          <RouterLink
            class="no-underline text-gray-600 hover:text-secondary py-2 border-b-2 border-b-transparent hover:border-b-secondary-alt duration-200"
            :to="{ name: 'app_plan_list', params: {district: currentDistrict.id} }"
          >
            Plans
          </RouterLink>

          <MenuDropdown v-if="user.roles.includes(Role.Admin)">
            <template #dropdownText>
              <i class="fa-solid fa-cog" />
              <span class="sr-only">Settings</span>
            </template>

            <AppDropdownItem
              :to="{ name: 'app_user_list' }"
              class="border-b"
              text="Users"
            />

            <AppDropdownItem
              :to="{ name: 'app_district_list' }"
              class="border-b"
              text="Districts"
            />

            <AppDropdownItem
              :to="{ name: 'app_province_list' }"
              class="border-b"
              text="Provinces"
            />

            <AppDropdownItem
              :to="{ name: 'app_framework_list' }"
              class="border-b"
              text="Frameworks"
            />

            <AppDropdownItem
              :to="{ name: 'app_setting_list' }"
              text="Settings"
            />
          </MenuDropdown>
        </div>

        <!-- Profile -->
        <DropdownNavProfile>
          <AppDropdownItem
            :to="{ name: 'app_auth_change_password' }"
            class="cursor-pointer hover:bg-gray-100 right-0 border-b"
            text="Change password"
          />

          <AppDropdownItem
            class="cursor-pointer hover:bg-gray-100 right-0"
            text="Logout"
            @click="logout"
          />
        </DropdownNavProfile>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import { MenuDropdown, AppDropdownItem, DropdownNavProfile } from '@/components/dropdowns';

import Logo from '@/assets/images/logos/living-plans-logo.svg';
import { Role } from '@/const';
import { useHttp } from '@/composables';
import { useAuthStore } from '@/store';

const authStore = useAuthStore();
const router = useRouter();
const currentDistrict = computed(() => authStore.user.districts.find(district => district.current));
const user = authStore.user;

const logout = async () => {
  const response = await useHttp().post('auth/logout');

  if (response.statusCode === HttpStatusCode.Ok) {
    authStore.user = null;
    await router.push({ name: 'app_framework_list' });
  }
};
</script>
